import React from 'react';
import { connect } from 'react-redux';
import { RecipeButton } from '../RecipeButton';


class RecipeCategory extends React.Component {

  render() {
    const {favorites, openModal, cocktailCategory} = this.props;

      return (
        <div style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
          {cocktailCategory.map((thisRecipe, index) =>
            <RecipeButton thisRecipe={thisRecipe} favorites={favorites} openModal={openModal} />
          )
          }
        </div>
      )
  }
}

const connectedRecipeCategory = connect(null)(RecipeCategory);
export { connectedRecipeCategory as RecipeCategory };


// WEBPACK FOOTER //
// ./src/RecipeCategory/RecipeCategory.jsx